// Use singletons since this is only analyzed when the bundle is loaded, so no
// harm, which also allow us to export a literal instead of needing a func.
//
// We’re not converting this to TypeScript since it doesn’t allow the
// module.exports updating that we’re relying on here.
export let isTesting: boolean,
  isDev: boolean,
  isProd: boolean,
  useLocalApi: boolean,
  useLocalLoginApp: boolean;

getEnvValues();

function getEnvValues() {
  // import.meta.env only exists under Vite; Node scripts (scripts/*.ts via tsx)
  // that import app modules get an empty environment instead.
  const env = import.meta.env ?? {};
  isTesting = env.MODE === 'test';
  isDev = env.MODE === 'development';
  isProd = env.MODE === 'production';
  useLocalApi = !!env.VITE_USE_LOCAL_API;
  useLocalLoginApp = !!env.VITE_USE_LOCAL_LOGIN_APP;
}
